<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	let className = '';
	export { className as class };
</script>

{#if $showNewLayout}
	<div class="d-flex justify-content-center {className}">
		<Container type="glass" padding="m" noScroll class="text-center">
			<div class="d-flex flex-direction-column align-items-center">
				<slot />
			</div>
		</Container>
	</div>
{:else}
	<div class="text-center d-flex flex-direction-column align-items-center {className}">
		<slot />
	</div>
{/if}
